import { Component, Input } from '@angular/core';
import {
  AlignmentEnum,
  BannerTypeEnum,
  FullWidthBannerComponentData,
  ImageLoadingStrategy,
  MediaContainer,
} from '@boels/models';
import { CommonModule } from '@angular/common';
import { MediaComponent } from '../../media/media.component';
import { ButtonComponent } from '../../button/button.component';
import { GenericLinkDirective } from '@boels/helpers';

@Component({
  imports: [
    CommonModule,
    MediaComponent,
    ButtonComponent,
    GenericLinkDirective,
  ],
  selector: 'boels-banner-markup-media-container',
  templateUrl: './banner-markup-media-container.component.html',
  styleUrls: ['./banner-markup.component.scss'],
})
export class BannerMarkupMediaContainerComponent {
  @Input() bannerComponent: FullWidthBannerComponentData;
  @Input() withImage?: MediaContainer;
  @Input() removeGradient: boolean;
  @Input() bannerType: BannerTypeEnum;
  public alignment = AlignmentEnum;
  public ImageLoadingStrategy = ImageLoadingStrategy;
}
